export default function Selection (query) {
    const elements = document.querySelectorAll(query);
    if (!elements || !elements.length) return;

    [...elements].forEach((select) => {
        const control = select.querySelector('input:not(.site-field--trigger)');
        const trigger = select.querySelector('.site-field--trigger');
        const items = [...select.querySelectorAll('.site-field--dropdown li')];

        document.documentElement.addEventListener('click', (event) => {
            event.stopPropagation();

            select.classList.remove('collapsed');
        });

        trigger.addEventListener('click', (event) => {
            event.stopPropagation();

            if (select.classList.contains('collapsed')) {
                select.classList.remove('collapsed');
            } else {
                select.classList.add('collapsed');
            }
        });

        [...items].forEach((item) => {
            item.addEventListener('click', (event) => {
                event.stopPropagation();

                const { value } = item.dataset;
                const label = item.textContent;

                control.value = value;
                trigger.value = label;

                control.dispatchEvent(new Event('change'));

                [...items].forEach((i) => i.classList.remove('active'));

                item.classList.add('active');

                select.classList.remove('collapsed');
            });
        });

        items[0].click();
    });
}
